export const getFlagUrl = (name: string): string => {
  const countryName =
    name === 'United States' ? 'United States of America' : name;
  const formattedName = countryName.replace(/\s/g, '-').toLowerCase();
  return name === 'Argentina'
    ? 'https://www.countryflags.com/wp-content/uploads/flag-jpg-xl-7-scaled.jpg'
    : `https://www.countryflags.com/wp-content/uploads/${formattedName}-flag-png-large.png`;
};
